import type {
  AdminCreateRequest,
  AdminListItem,
  SettingsResponse,
  SettingsUpdateRequest,
} from '@ayub/shared'
import { apiDelete, apiGet, apiPatch, apiPost } from '@/lib/api'

/** `GET /api/settings` — har qanday admin o'qiy oladi (`routes/settings.ts` izohi). */
export function fetchSettings(): Promise<SettingsResponse> {
  return apiGet<SettingsResponse>('/settings')
}

/**
 * `PATCH /api/settings` — faqat super admin (server 403 bilan rad etadi, `SettingsPage.tsx`
 * shu xatoni ushlab ko'rsatadi). `body` faqat O'ZGARGAN maydonlarni o'z ichiga oladi —
 * dirty-tracking `SettingsPage.tsx`da, bu funksiya shunchaki tayyor tanani yuboradi.
 */
export function updateSettingsRequest(body: SettingsUpdateRequest): Promise<SettingsResponse> {
  return apiPatch<SettingsResponse>('/settings', body)
}

/** `GET /api/admins` — ro'yxat, super bo'lmagan adminlar ham o'qiy oladi. */
export function fetchAdmins(): Promise<AdminListItem[]> {
  return apiGet<AdminListItem[]>('/admins')
}

/** `POST /api/admins` — faqat super admin. Yangi admin har doim `isSuper: false`. */
export function createAdminRequest(body: AdminCreateRequest): Promise<AdminListItem> {
  return apiPost<AdminListItem>('/admins', body)
}

/**
 * `DELETE /api/admins/:id` — `:id` aynan `telegramId` (`AdminListItem`da alohida raqamli
 * `id` yo'q, `packages/shared/src/api.ts` izohiga qarang).
 */
export function deleteAdminRequest(telegramId: number): Promise<{ ok: true }> {
  return apiDelete<{ ok: true }>(`/admins/${telegramId}`)
}
